const messages: Record<string, string> = {
	'loader.loading': 'Cargando…',
	'loader.error': 'La pagina no se ha podido cargar. Por favor, inténtalo de nuevo más tarde…',
	'connectionError.title': 'Error de conexión',
	'connectionError.description': 'Error de conexión. Por favor, sube tus fotografías de nuevo.',
	'mainError.tryAgain': 'Por favor, inténtalo de nuevo',
	'landing.headline.policyCheck': '¡Bienvenido!',
	'landing.paragraph': 'Te queda poco para terminar el proceso',
	'landing.stepDescription.fourAdditionalPictures': 'Envía las imágenes',
	'landing.stepDescription.fourDiagonalPerspectives':
		'Por favor, toma las fotografías que te indicamos durante el proceso',
	'landing.stepDescription.feedback': '¿Podrías darnos tu opinión sobre el proceso?',
	'landing.termsAndConditionsLink': 'Acepto los términos y condiciones',
	'landing.additional-informations-section.title':
		'Por favor, antes de comenzar la fotoverificación de tu vehículo, asegúrate de que:',
	'landing.additional-informations-section.text':
		'<ul>' +
		"<li class='landing-additional-information-line'>Te encuentras en un lugar con buena cobertura y buena iluminación</li>" +
		"<li class='landing-additional-information-line'>El vehículo es accesible al completo desde todos los ángulos y todas las ventanillas son visibles</li>" +
		'</ul>',
	'dataPrivacyModal.headline': 'Acepto los términos y condiciones',
	'button.start': 'Comenzar',
	'button.accept': 'Aceptar',
	'button.back': 'Atrás',
	'button.close': 'Cerrar',
	'landing.aboutPolicyCheck': '¿Qué es PolicyCheck?',
	'tutorialModal.headline.first.policyCheck': '¿Qué hay detrás de PolicyCheck?',
	'tutorialModal.paragraph.first.policyCheck':
		'PolicyCheck es una fotoverificación rápida de tu vehículo. ',
	'tutorialModal.paragraph.second': ' ',
	'chooseLang.headline': 'Elige el idioma en el que quieres continuar con el proceso',

	'vehicleImages.overviewPhotos': 'Vista general del vehículo',
	'vehicleImages.overviewPhotos.subtitle': 'Fotografía el vehículo',
	'vehicleImages.description':
		'Realiza fotografías diagonales de las partes frontales derecha e izquierda y de las partes traseras, derecha e izquierda que incluyan todo el vehículo y estén bien iluminadas. La matrícula debe estar bien visible en todas las fotografías',
	'editPhoto.edit': 'Cambiar imagen',
	'button.next': 'Siguiente',
	'imageRecognitionFeedback2.exemplaryPhoto': 'Ejemplo',

	'imageRecognitionMismatchModal.headline':
		'¿Estás seguro de haber realizado la fotografía correcta siguiendo las indicaciones de iluminación y posición?',
	'button.continue': 'Continuar',
	'button.backchangeImage': 'Cambiar foto',

	'fourPerspectivesExampleModal.headline.first': 'Ejemplo de la vista general del vehículo',
	'fourPerspectivesExampleModal.button.close': 'Cerrar',

	'fourDiagonalPerspectives.vehicleFrontRight.title':
		'Fotografía en diagonal que cubra la totalidad de la parte frontal derecha del vehículo',
	'fourDiagonalPerspectives.vehicleRearRight.title':
		'Fotografía en diagonal que cubra la totalidad  de la parte trasera derecha del vehículo',
	'fourDiagonalPerspectives.vehicleRearLeft.title':
		'Fotografía en diagonal que cubra la totalidad de la parte trasera izquierda del vehículo',
	'fourDiagonalPerspectives.vehicleFrontLeft.title':
		'Fotografía en diagonal que cubra la totalidad de la parte frontal izquierda del vehículo',

	'vehicleImages.rightFrontOverview': 'Diagonal de la parte frontal derecha',
	'vehicleImages.rightRearOverview': 'Diagonal de la parte trasera derecha',
	'vehicleImages.leftFrontOverview': 'Diagonal de la parte frontal izquierda',
	'vehicleImages.leftRearOverview': 'Diagonal de la parte trasera izquierda',

	'button.changeImage': 'Cambiar foto',
	'button.deleteImage': 'Borrar foto',

	'completeVehicleImagesModal.description': 'Por favor, completa la siguiente información',
	'completeVehicleImagesModal.headline': '¡Atención!',
	'completeVehicleImagesModal.hasVehicleImageFrontLeft':
		'Fotografía que cubra la totalidad de la parte frontal izquierda del vehículo',
	'completeVehicleImagesModal.hasVehicleImageRearLeft':
		'Fotografía que cubra la totalidad de la parte trasera derecha del vehículo',
	'completeVehicleImagesModal.hasVehicleImageFrontRight':
		'Fotografía que cubra la totalidad de la parte frontal  derecha del vehículo ',
	'completeVehicleImagesModal.hasVehicleImageRearRight':
		'Fotografía que cubra la totalidad de la parte trasera izquierda del vehículo',

	'feedback.headline.policyCheck': '¡Hemos recibido las fotografías correctamente!',
	'feedback.rating.policyCheck':
		'¿Cómo valorarías tu experiencia con la app siendo 5 la máxima puntuación?',
	'feedback.yourOpinion': 'Comentarios',
	'feedback.button.send': 'Enviar',

	'thanks.headline.first': '¡Muchas gracias por tu valoración!',
	'thanks.paragraph.first': 'Gracias por la confianza en Allianz Direct',

	'waitForAudit.thankYou': '¡Muchas gracias por tu valoración!',
	'waitForAudit.description.damageFound': 'Gracias por la confianza en Allianz Direct',
	'waitForAudit.description.damageNotFound': 'Gracias por la confianza en Allianz Direct',

	'blockedByDevice.headline': 'No se puede abrir PolicyCheck desde un ordenador',
	'blockedByDevice.description':
		'No se puede abrir PolicyCheck desde un ordenador\r\nLa plataforma de Policycheck solo registra fotoverificaciones realizadas desde el teléfono movil. Para continuar, por favor, abre el enlace de PolicyCheck desde un teléfono.',

	'landing.additional-informations-section.text.motorbike':
		'<ul>' +
		"<li class='landing-additional-information-line'>Te encuentras en un lugar con buena cobertura y buena iluminación</li>" +
		"<li class='landing-additional-information-line'>El vehículo es accesible al completo desde todos los angulos.</li>" +
		'</ul>',
	'vehicleImages.description.motorbike':
		'Realiza fotografías diagonales de las partes frontales derecha e izquierda y de las partes traseras, derecha e izquierda que incluyan todo el vehículo y estén bien iluminadas. La matrícula debe estar bien visible en las fotografías traseras.',

	'fourAdditionalPictures.mileage.title': 'Cuentakilómetros',
	'dashboardMileage.dashboard.paragraph':
		'Por favor, haz una foto del cuentakilómetros del vehículo. Si tu vehículo tiene un cuentakilómetros digital, por favor, enciéndelo',
	'dashboardMileage.paragraph.first': 'Indícanos el número de kilómetros que tiene el vehículo',
	'dashboardMileage.placeholder': 'Por ejemplo, 150 000 km',

	'fourDiagonalPerspectives.vehicleFrontLeft.exampleModalTitle':
		'Ejemplo de la vista general del vehículo',
	'fourDiagonalPerspectives.vehicleRearLeft.exampleModalTitle':
		'Ejemplo de la vista general del vehículo',
	'fourDiagonalPerspectives.vehicleRearRight.exampleModalTitle':
		'Ejemplo de la vista general del vehículo',
	'fourDiagonalPerspectives.vehicleFrontRight.exampleModalTitle':
		'Ejemplo de la vista general del vehículo',

	'fourAdditionalPictures.windshield.title': 'Parabrisas frontal del vehículo',
	'fourAdditionalPictures.windshield.description':
		'Por favor, haz una fotografía detallada del parabrisas frontal del vehículo',

	'fourAdditionalPicturesExampleModal.headline.first': 'Añade fotos adicionales',

	'completeFourAdditionalPicturesModal.description': 'Por favor, completa la siguiente información',
	'completeFourAdditionalPicturesModal.hasMileageImage': 'Fotografía de los kilómetros',
	'completeFourAdditionalPicturesModal.hasWindshieldImage':
		'Fotografía del parabrisas frontal del vehículo',
	'completeFourAdditionalPicturesModal.headline': '¡Atención!',

	'invalidFile.size.title': 'Tamaño de la imagen incorrecto',
	'invalidFile.size.description': 'El tamaño de la imagen es mayor que el máximo requerido.',
	'invalidFile.extension.title': 'El sistema no admite este tipo de archivo',
	'invalidFile.extension.description':
		'El sistema no admite el tipo de archivo adjuntado. Tipos de archivos admitidos: .jpg, .jpeg, .jfif, .heic, .heif, .png y .bmp',
};

export default messages;
